import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "py-4 px-6"
};
const _hoisted_2 = {
  class: "p-4"
};
const _hoisted_3 = {
  class: "py-2"
};
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
export default {
  __name: 'UpgradeToProExpenseAttachmentsModals',
  props: {
    routeService: {
      type: Object,
      required: true
    },
    tracking: {
      type: Object,
      required: true
    }
  },
  emits: ["cancel", "openSupportLink"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    props.tracking?.event("Clicked", "Upgrade to pro modals opened", {
      UpgradeToProModalsOpened: true
    });
    const emits = __emit;
    const goToSubscription = () => {
      emits("cancel");
      props.tracking?.event("Clicked", "Go To Subscription", {
        GoToSubscription: true
      });
      props.routeService.go("settings.company.maxioCompanySubscription");
    };
    return (_ctx, _cache) => {
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_spacer = _resolveComponent("v-spacer");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      return _openBlock(), _createBlock(_component_v_card, {
        title: "Expense attachments"
      }, {
        append: _withCtx(() => [_createVNode(LlSecondaryButton, {
          icon: "mdi-close",
          variant: "text",
          density: "compact",
          "aria-label": "Close",
          onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('cancel'))
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[9] || (_cache[9] = _createElementVNode("p", {
          class: "block text-base font-medium"
        }, " Expense attachments are a Pro feature. ", -1)), _cache[10] || (_cache[10] = _createElementVNode("p", {
          class: "text-base font-medium"
        }, " Upgrade now to minimize headaches and free up time for more of what matters. ", -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("p", null, [_createVNode(_component_v_icon, {
          color: "success"
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("mdi-check-bold", -1)]))]),
          _: 1
        }), _cache[4] || (_cache[4] = _createElementVNode("span", {
          class: "pl-2"
        }, "Sync attachments from QuickBooks", -1))]), _createElementVNode("p", null, [_createVNode(_component_v_icon, {
          color: "success"
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("mdi-check-bold", -1)]))]),
          _: 1
        }), _cache[6] || (_cache[6] = _createElementVNode("span", {
          class: "pl-2"
        }, "Add and manage files from LeanLaw", -1))]), _createElementVNode("p", null, [_createVNode(_component_v_icon, {
          color: "success"
        }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("mdi-check-bold", -1)]))]),
          _: 1
        }), _cache[8] || (_cache[8] = _createElementVNode("span", {
          class: "pl-2"
        }, "Send attachments through email or download with LEDES files", -1))])])]), _createVNode(_component_v_card_actions, {
          class: "tw"
        }, {
          default: _withCtx(() => [_createVNode(_component_v_spacer), _createVNode(LlSecondaryButton, {
            variant: "outlined",
            onClick: _cache[1] || (_cache[1] = $event => _ctx.$emit('openSupportLink'))
          }, {
            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode("Learn More", -1)]))]),
            _: 1
          }), _createVNode(LlSecondaryButton, {
            color: "primary",
            onClick: _cache[2] || (_cache[2] = $event => goToSubscription())
          }, {
            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode("Upgrade Now", -1)]))]),
            _: 1
          })]),
          _: 1
        })])]),
        _: 1
      });
    };
  }
};